import { createFileRoute } from '@tanstack/react-router';
import { DevelopersTab } from '@/features/integrations';

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/integrations/all/developers')({
  component: DevelopersTab,
});
